import api from '../../plugins/api';

const getValues = (params) => {
  return api.get('/api/services/getValues', params);
};

export default getValues;
